const preparedDataInput =  {
    methods: {
        preparedDataInput(form) {
            let fd = new FormData();
            fd.append("changeBlockInfo", this.changeBlockInfo);
            let listFieldSubmit = this.mapGroupFieldAmsCustomer[this.changeBlockInfo];
            for (let field in listFieldSubmit) {
                const fieldNameSubmit = listFieldSubmit[field];
                if (fieldNameSubmit === "investmentView" || fieldNameSubmit === "boInvestmentPurposeView" || fieldNameSubmit === "cryptInvestmentPurposeView") {
                    for (let investmentField in form.input["amsCustomerDetail." + fieldNameSubmit]) {
                        fd.append("amsCustomerDetail." + fieldNameSubmit + "." + investmentField, form.input["amsCustomerDetail." + fieldNameSubmit][investmentField]);
                    }
                } else if (fieldNameSubmit.indexOf("file") === 0) {
                    if (fieldNameSubmit.indexOf("fileList") === 0) {
                        if (form[fieldNameSubmit]) {
                            let indexHasFile = 0

                            for (let i = 0; i < form[fieldNameSubmit].length; i++) {
                                if(form[fieldNameSubmit][i]) {
                                    const key = Object.keys(form[fieldNameSubmit][i])[0]; // lấy key đầu tiên phải là dạng File
                                    const file = form[fieldNameSubmit][i][key];

                                    if (file && file instanceof File) {
                                        fd.append("fileUploades[" + indexHasFile + "]", file);
                                        fd.append("fileUploadesFileNames[" + indexHasFile + "]", file.name);

                                        indexHasFile++;
                                    }
                                }
                            }
                        }
                    } else {
                        let indexHasFile = [];
                        for (let i = 1; i < 4; i++) {
                            if (form[fieldNameSubmit + i] != null) {
                                indexHasFile.push(i);
                            }
                        }
                        for (let i = 0; i < indexHasFile.length; i++) {
                            fd.append("fileUploades[" + i + "]", form[fieldNameSubmit + indexHasFile[i]]);
                            fd.append("fileUploadesFileNames[" + i + "]", form[fieldNameSubmit + indexHasFile[i]].name);
                        }
                    }
                } else {
                    let valueOfField = form.input["amsCustomerDetail." + fieldNameSubmit] === undefined ? null : form.input["amsCustomerDetail." + fieldNameSubmit];
                    if (fieldNameSubmit === "boLossMaxAmount") {
                        valueOfField = valueOfField.replace(/[^0-9]/g, '');
                    }
                    if (valueOfField != null) {
                        fd.append("amsCustomerDetail." + fieldNameSubmit, valueOfField);
                    }
                }
            }

            return fd;
        },

        updateBlockInfo(key) {
            this.changeBlockInfo = key;
            this.$refs[key].reverseInput(key);
        },
        validateInvestment(input) {
            return input['amsCustomerDetail.investmentView.purposeEconomicFlg'] == 0 &&
                input['amsCustomerDetail.investmentView.purposeHighIntFlg'] == 0 &&
                input['amsCustomerDetail.investmentView.purposeHedgeAssetFlg'] == 0 &&
                input['amsCustomerDetail.investmentView.purposeSwapFlg'] == 0 &&
                input['amsCustomerDetail.investmentView.purposeExchangeFlg'] == 0 &&
                input['amsCustomerDetail.investmentView.purposeLongTermFlg'] == 0 &&
                input['amsCustomerDetail.investmentView.purposeShortTermFlg'] == 0;
        }
    },
}

export default preparedDataInput;













